import Button from '@Components/Buttons/Button'
import React, { useContext } from 'react'
import { WorkType } from '@Components/ViewWork/work-type'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'

interface EditButton {
    workType?: WorkType
    linkTo: string
    wizardFlowIndex: number
}

const EditButton = ({ workType, linkTo, wizardFlowIndex }: EditButton) => {
    const { wizardFlowStore } = useContext(StoresContext)

    return (
        <>
            {workType === 'create-wizard' ? (
                <Button
                    mainColor={false}
                    type="primary-small"
                    onClick={() => {
                        wizardFlowStore.setCurrentIndex(wizardFlowIndex)
                    }}
                >
                    Edit
                </Button>
            ) : (
                <Button mainColor={false} type="primary-small" typeLink linkTo={linkTo}>
                    Edit
                </Button>
            )}
        </>
    )
}

export default observer(EditButton)
